/**
 * Product price component
 *
 * @module product-price
 * @version 1.0.0
 * @extends HTMLElement
 */

customElements.component = 'product-price';

if(!customElements.get(customElements.component)) {

    class productPrice extends HTMLElement {

        /**
         * Web component constructor
         *
         * @constructor
         */
        constructor() {

            super();

            this.placement = this.parentNode.dataset.placement;
            this.associatedForm = this.closest('form');
            this.associatedQtySelector = this.associatedForm?.querySelector('quantity-selector');
            this.associatedPricingTable = this.associatedForm?.querySelector('tooltip-pricing-table');
            this.classList.add('price');

            this.dataset.ready = (this.getPriceElement()) ? "true" : "false";
            this.initEvents();

            window.theme.product.loadProduct(this.dataset.handle).then(product => {

                this.product = product;

                this.render(product);
            });
        }

        /**
         * Init component events
         *
         * @param {object} product Product data.
         * @returns {undefined}
         */
        initEvents() {
            /*console.log('Associated Form:', this.associatedForm);
            console.log('QTY Selector:', this.associatedQtySelector);
            console.log('Tooltip Pricing Table:', this.associatedPricingTable);*/

            this.associatedQtySelector?.querySelector('input').addEventListener('change', event => {
                let currentVariant = this.product.variants.find(v => v.id === parseInt(this.dataset.currentVariantId));
                let priceInButton = this.associatedForm?.querySelector(`addtocart-button product-price [data-price]`);
                let comparePriceInButton = this.associatedForm?.querySelector(`addtocart-button product-price [data-price-compared]`);
                let currentInputValue = this.associatedQtySelector?.querySelector('input').value;
                this.associatedPricingTable.generatePricingTable(currentVariant.id);
                let pricingBreak = this.getPricingBreak(Number(currentInputValue), this.associatedPricingTable.pricingBreaks);

                if (priceInButton) {
                    if (pricingBreak) {
                        priceInButton.innerHTML = theme.money.format(pricingBreak.totalPrice * 100);
                    } else {
                        priceInButton.innerHTML = theme.money.format(currentVariant.price * Number(event.target.value));
                    }
                }

                if (comparePriceInButton) {
                    comparePriceInButton.innerHTML = theme.money.format(currentVariant.compare_at_price * Number(event.target.value));
                }
            });
        }

        getPricingBreak(quantity, pricingBreaks) {
            if (!pricingBreaks) return null;

            const pricing = pricingBreaks.find(({ quantityRange }) => {
                const [min, max] = quantityRange.split('-').map(Number);
                return quantity >= min && (isNaN(max) || quantity <= max);
            });

            if (!pricing) return null; // Handle edge case if no range matches

            // Extract numeric value from price string
            const priceMatch = pricing.price.match(/[\d.]+/);
            const unitPrice = priceMatch ? parseFloat(priceMatch[0]) : 0;

            // Calculate total price
            const totalPrice = unitPrice * quantity;

            return { ...pricing, unitPrice, totalPrice };
        }

        /**
         * Render component in the DOM
         *
         * @param {object} product Product data.
         * @returns {undefined}
         */
        render(product) {

          let componentDefaultStyle = ["flex", "items-center"];
          this.classList.add(...componentDefaultStyle);

          if (product.compare_at_price_varies == false) {
            if (!this.dataset.hideComparedPrice) {
              this.setComparedPrice(product.compare_at_price);
            }
          }

          this.setPrice(product.price);

          this.dataset.ready = "true";
        }

        /**
         * Set price
         *
         * @param {number} price Product price.
         * @returns {undefined}
         */
        setPrice(price) {
            let formInput = this.associatedQtySelector?.querySelector('input');
            let priceElement = this.getPriceElement();
            let priceDefaultStyle = ["font-body", "text-gray-100", "font-bold"];
            let additionalStyle = [...this.classList];
            additionalStyle.splice(additionalStyle.indexOf('price'));

            if (!priceElement) {
                priceElement = document.createElement('span');
                priceElement.dataset.price = price.toString();
                this.append(priceElement);
            }

            priceElement.innerHTML = theme.money.format(price);
            priceElement.classList.add(...priceDefaultStyle, ...additionalStyle);
        }

        /**
         * Set compared price
         *
         * @returns {undefined}
         */
        hideComparedPrice() {
            let comparedPriceElements = this.closest('form')?.querySelectorAll('[data-price-compared]');

            if (comparedPriceElements) {
                comparedPriceElements.forEach((comparedPriceElement) => {
                    comparedPriceElement.style.display = 'none';
                });
            }
        }

        /**
         * Set compared price
         *
         * @param {number} price Product price.
         * @returns {undefined}
         */
        setComparedPrice(price) {
            let comparedPriceDefaultStyle = ["font-body", "text-gray-200", "font-normal"];
            let additionalStyle = this.dataset.classCompared ? this.dataset.classCompared.split(' ') : [];
            let comparedPriceElements = this.closest('form')?.querySelectorAll('[data-price-compared]');

            if (!price) {
                if (!comparedPriceElements) return;

                comparedPriceElements.forEach((comparedPriceElement) => {
                    comparedPriceElement.remove();
                });
            }

            if (price && comparedPriceElements.length) {
                comparedPriceElements.forEach((comparedPriceElement) => {

                    if (!comparedPriceElement) {
                        comparedPriceElement = document.createElement('span');
                        comparedPriceElement.dataset.priceCompared = price;
                        comparedPriceElement.dataset.amount = theme.money.format(price);
                        this.append(comparedPriceElement);
                    } else {
                        comparedPriceElement.dataset.amount = theme.money.format(price);
                        comparedPriceElement.style.display = 'block';
                    }

                    comparedPriceElement.innerHTML = theme.money.format(price);
                    comparedPriceElement.classList.add(...comparedPriceDefaultStyle, ...additionalStyle);
                });
            }
        }

        /**
         * Update product price.
         *
         * @param {integer} variantId Variant id.
         * @returns {undefined}
         */
        update(variantId) {
            //console.log('variantID:', variantId);

            let variant = window.theme.product.getVariant(variantId, this.product);
            //console.log('variant:', variant);

            if (variant) {
                this.associatedForm?.querySelectorAll('product-price').forEach((productPriceElement) => {productPriceElement.setAttribute('data-current-variant-id', variant.id)});

                if (variant.compare_at_price) {
                    this.setComparedPrice(variant.compare_at_price);
                    let comparePriceInButtons = this.associatedForm?.querySelectorAll(`product-price [data-price-compared]`);
                    if (comparePriceInButtons) {
                        comparePriceInButtons.forEach((comparePriceInButton) => {
                            comparePriceInButton.innerHTML = theme.money.format(variant.compare_at_price * Number(this.associatedForm.querySelector('.quantity-input-selector').value));
                        });
                    }
                } else {
                    this.hideComparedPrice();
                }

                if (variant.price) {
                    this.setPrice(variant.price);

                    let priceInButtons = this.associatedForm?.querySelectorAll(`addtocart-button product-price [data-price]`);
                    if (priceInButtons) {
                        let currentInputValue = this.associatedQtySelector?.querySelector('input').value;
                        this.associatedPricingTable.generatePricingTable(variant.id);
                        let pricingBreak = this.getPricingBreak(Number(currentInputValue), this.associatedPricingTable.pricingBreaks);

                        priceInButtons.forEach((priceInButton) => {
                            if (pricingBreak) {
                                priceInButton.innerHTML = theme.money.format(pricingBreak.totalPrice * 100);
                            } else {
                                priceInButton.innerHTML = theme.money.format(variant.price * Number(currentInputValue));
                            }
                        });
                    }
                } else {
                    console.log('Price not found');
                }

            } else {

                console.log('Variant not found');
            }
        }

        /**
         * Get price element.
         *
         * @returns {undefined}
         */
        getPriceElement() {
            return this.querySelector('[data-price]');
        }
    }

    customElements.define(customElements.component, productPrice);
}
